export interface ResortFAQ {
  questionKey: string;
  answerKey: string;
}

export interface ResortRegionConfig {
  id: string;
  slug: string;
  nameKey: string;
  heroImage: string;
  ogImage: string;
  seoContentKey: string;
  metaTitleKey: string;
  metaDescriptionKey: string;
  faqs: ResortFAQ[];
}

const BRASIL_FAQS: ResortFAQ[] = [
  { questionKey: 'resorts.faq.brasil.q1', answerKey: 'resorts.faq.brasil.a1' },
  { questionKey: 'resorts.faq.brasil.q2', answerKey: 'resorts.faq.brasil.a2' },
  { questionKey: 'resorts.faq.brasil.q3', answerKey: 'resorts.faq.brasil.a3' },
  { questionKey: 'resorts.faq.brasil.q4', answerKey: 'resorts.faq.brasil.a4' },
  { questionKey: 'resorts.faq.brasil.q5', answerKey: 'resorts.faq.brasil.a5' },
];

const CARIBE_FAQS: ResortFAQ[] = [
  { questionKey: 'resorts.faq.caribe.q1', answerKey: 'resorts.faq.caribe.a1' },
  { questionKey: 'resorts.faq.caribe.q2', answerKey: 'resorts.faq.caribe.a2' },
  { questionKey: 'resorts.faq.caribe.q3', answerKey: 'resorts.faq.caribe.a3' },
  { questionKey: 'resorts.faq.caribe.q4', answerKey: 'resorts.faq.caribe.a4' },
  { questionKey: 'resorts.faq.caribe.q5', answerKey: 'resorts.faq.caribe.a5' },
];

const AFRICA_FAQS: ResortFAQ[] = [
  { questionKey: 'resorts.faq.africa.q1', answerKey: 'resorts.faq.africa.a1' },
  { questionKey: 'resorts.faq.africa.q2', answerKey: 'resorts.faq.africa.a2' },
  { questionKey: 'resorts.faq.africa.q3', answerKey: 'resorts.faq.africa.a3' },
  { questionKey: 'resorts.faq.africa.q4', answerKey: 'resorts.faq.africa.a4' },
  { questionKey: 'resorts.faq.africa.q5', answerKey: 'resorts.faq.africa.a5' },
];

const EUROPA_FAQS: ResortFAQ[] = [
  { questionKey: 'resorts.faq.europa.q1', answerKey: 'resorts.faq.europa.a1' },
  { questionKey: 'resorts.faq.europa.q2', answerKey: 'resorts.faq.europa.a2' },
  { questionKey: 'resorts.faq.europa.q3', answerKey: 'resorts.faq.europa.a3' },
  { questionKey: 'resorts.faq.europa.q4', answerKey: 'resorts.faq.europa.a4' },
  { questionKey: 'resorts.faq.europa.q5', answerKey: 'resorts.faq.europa.a5' },
];

const OUTROS_FAQS: ResortFAQ[] = [
  { questionKey: 'resorts.faq.outros.q1', answerKey: 'resorts.faq.outros.a1' },
  { questionKey: 'resorts.faq.outros.q2', answerKey: 'resorts.faq.outros.a2' },
  { questionKey: 'resorts.faq.outros.q3', answerKey: 'resorts.faq.outros.a3' },
  { questionKey: 'resorts.faq.outros.q4', answerKey: 'resorts.faq.outros.a4' },
  { questionKey: 'resorts.faq.outros.q5', answerKey: 'resorts.faq.outros.a5' },
];

export const RESORT_REGIONS: Record<string, ResortRegionConfig> = {
  brasil: {
    id: 'brasil',
    slug: 'brasil',
    nameKey: 'resorts.destinations.brasil',
    heroImage: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?auto=format&fit=crop&w=1920&q=80',
    ogImage: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?auto=format&fit=crop&w=1200&h=630&q=80',
    seoContentKey: 'resorts.regions.brasil.seoContent',
    metaTitleKey: 'resorts.regions.brasil.metaTitle',
    metaDescriptionKey: 'resorts.regions.brasil.metaDescription',
    faqs: BRASIL_FAQS,
  },
  caribe: {
    id: 'caribe',
    slug: 'caribe',
    nameKey: 'resorts.destinations.caribe',
    heroImage: 'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?auto=format&fit=crop&w=1920&q=80',
    ogImage: 'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?auto=format&fit=crop&w=1200&h=630&q=80',
    seoContentKey: 'resorts.regions.caribe.seoContent',
    metaTitleKey: 'resorts.regions.caribe.metaTitle',
    metaDescriptionKey: 'resorts.regions.caribe.metaDescription',
    faqs: CARIBE_FAQS,
  },
  africa: {
    id: 'africa',
    slug: 'africa',
    nameKey: 'resorts.destinations.africa',
    heroImage: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&w=1920&q=80',
    ogImage: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&w=1200&h=630&q=80',
    seoContentKey: 'resorts.regions.africa.seoContent',
    metaTitleKey: 'resorts.regions.africa.metaTitle',
    metaDescriptionKey: 'resorts.regions.africa.metaDescription',
    faqs: AFRICA_FAQS,
  },
  europa: {
    id: 'europa',
    slug: 'europa',
    nameKey: 'resorts.destinations.europa',
    heroImage: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1920&q=80',
    ogImage: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1200&h=630&q=80',
    seoContentKey: 'resorts.regions.europa.seoContent',
    metaTitleKey: 'resorts.regions.europa.metaTitle',
    metaDescriptionKey: 'resorts.regions.europa.metaDescription',
    faqs: EUROPA_FAQS,
  },
  outros: {
    id: 'outros',
    slug: 'outros',
    nameKey: 'resorts.destinations.outros',
    heroImage: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1920&q=80',
    ogImage: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1200&h=630&q=80',
    seoContentKey: 'resorts.regions.outros.seoContent',
    metaTitleKey: 'resorts.regions.outros.metaTitle',
    metaDescriptionKey: 'resorts.regions.outros.metaDescription',
    faqs: OUTROS_FAQS,
  },
};

export const getResortRegionBySlug = (slug: string): ResortRegionConfig | undefined => {
  return RESORT_REGIONS[slug];
};